// @flow
import { TranslationAIActionTypes } from './constants';

type TranslationAIAction = { type: string, payload: {} | string };

// common success
export const translationAIApiResponseSuccess = (actionType: string, data: any): TranslationAIAction => ({
    type: TranslationAIActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const translationAIApiResponseError = (actionType: string, error: string): TranslationAIAction => ({
    type: TranslationAIActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const addTranslationAI = (translationAI:any):TranslationAIAction=>({
    type:TranslationAIActionTypes.ADD_TRANSLATION_AI,
    payload:translationAI
})

export const resetTranslationAIs = (): TranslationAIAction => ({
    type: TranslationAIActionTypes.RESET,
    payload: {},
});

